import {createFileRoute} from '@tanstack/react-router'
import CommunitiesView from "../../../players/CommunitiesView.tsx";

export const Route = createFileRoute('/_app/communities/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <CommunitiesView />
}
